import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5ae9e524")

_pushScopeId("data-v-5ae9e524")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "tbox clearfix" }, [
  /*#__PURE__*/_createVNode("div", { class: "t fl" }, "心率数据")
], -1)
const _hoisted_2 = { class: "health-report-cont chart-box" }
const _hoisted_3 = { class: "tip" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("加载中...")
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "echartsBox",
  id: "main"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_van_loading = _resolveComponent("van-loading")

  return (_openBlock(), _createBlock("div", {
    class: ["health-report card-universal", {'container-min-height': _ctx.loading && _ctx.loadFinished === false }]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_van_empty, {
          image: require('@/assets/img/loading-failure.png'),
          "image-size": 108,
          description: "加载失败，请下拉刷新页面"
        }, null, 8, ["image"]), [
          [_vShow, _ctx.loadFail]
        ]),
        (_ctx.loading && _ctx.loadFinished === false)
          ? (_openBlock(), _createBlock(_component_van_loading, {
              key: 0,
              style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)"},
              size: "30px",
              vertical: ""
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.loadFinished && _ctx.loadFail === false && (_ctx.heartRateData === null || _ctx.heartRateData.length === 0))
          ? (_openBlock(), _createBlock(_component_van_empty, {
              key: 1,
              image: "network",
              description: "无数据"
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_5
    ])
  ], 2))
})